package dev.lingvo.shared

/** A submitted signup-link label, never a URL or an inferred identity. */
enum class AcquisitionSource(val tag: String) {
    UNKNOWN("unknown"),
    SEARCH("search"),
    GITHUB("github"),
    AGENT("agent"),
    RECOMMENDATION("recommendation"),
    OTHER("other");

    companion object {
        fun fromTag(raw: String?): AcquisitionSource {
            if (raw == null || raw.length > 32) return UNKNOWN
            val tag = raw.trim().lowercase()
            return entries.firstOrNull { it.tag == tag } ?: UNKNOWN
        }
    }
}
